import React from 'react';
import { Typography, Button, Grid, Box } from '@mui/material';
import ModalBase from '../Controls/ModalBase';

const ContactoConfirmado = React.forwardRef((props, ref) => {
  const { open, setOpen, onClose } = props;

  const handleClose = () => {
    onClose();
  };

  const form = (
    <div>
      <Grid container direction='column' justifyContent='center' alignItems='center' spacing={1}>
        <Grid item>
          <Typography align='center' variant='body2' color='textSecondary'>
            Confirmaste tu correo electrónico de contacto para tu cuenta de usuario de OSER
          </Typography>
          <br />
          <Typography align='center' variant='body2' color='textSecondary'>
            A continuación podrás ingresar a mi.oser
          </Typography>
          <br />
        </Grid>
      </Grid>
      <Grid container direction='column' justifyContent='flex-end' alignItems='flex-end'>
        <Grid item>
          <Button size='small' variant='contained' color='primary' onClick={(e) => handleClose(e)}>
            Aceptar
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <ModalBase
        open={open}
        setOpen={setOpen}
        content={form}
        title='Correo electrónico confirmado'
        onClose={handleClose}
      />
    </Box>
  );
});

export default ContactoConfirmado;
